import type { CityConfig } from "../city-template/types";

export const ballwinMOConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Missouri Dept of Health Vital Records", href: "https://health.mo.gov/data/vitalrecords/", description: "Official Missouri vital records office in Jefferson City" },
    { label: "Marriage Licenses — St. Louis County Recorder of Deeds", href: "https://stlouiscountymo.gov/", description: "St. Louis County Recorder of Deeds — marriage license issuance" },
    { label: "Divorce Records — St. Louis County Circuit Clerk", href: "https://stlouiscountymo.gov/", description: "St. Louis County Circuit Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of MO DHSS for online vital record orders" },
  ],
  city: "Ballwin",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "ballwin-mo",
  route: "/cities/ballwin-mo",
  title: "Emergency Passport Ballwin, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Ballwin, MO — as fast as 24 hours. Serving West St. Louis County and the Manchester Road corridor. A+ BBB rated registered State Dept. courier serving Ballwin, Ellisville, and Manchester. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Ballwin, MO",
  heroSubtitle: "West St. Louis County business trip to London with a week to spare? Family vacation to Italy and passports expired? Manchester Road corridor corporate travel needs fast documents? We help Ballwin residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Ballwin%20Missouri%20suburban%20West%20St%20Louis%20County%20tree%20lined%20residential%20neighborhoods%20Manchester%20Road%20corridor%20commercial%20district%20Castlewood%20State%20Park%20Meramec%20River%20valley%20green%20rolling%20hills%20golden%20hour%20warm%20light%20professional%20photography%20Midwest%20suburban%20charm&width=1800&height=700&seq=ballwin-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Ballwin Missouri West St. Louis County suburban landscape at golden hour",
  geoPosition: "38.5942;-90.5432",
  geoPlacename: "Ballwin, Missouri",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 310 miles northeast of Ballwin via I-55",
  },
  nearbyCitiesZips: [
    { name: "Ballwin", zips: "63011, 63021" },
    { name: "Ellisville", zips: "63011, 63021" },
    { name: "Manchester", zips: "63011, 63021" },
    { name: "Wildwood", zips: "63005, 63011, 63021, 63038" },
    { name: "Town and Country", zips: "63131" },
    { name: "Des Peres", zips: "63131" },
    { name: "Chesterfield", zips: "63005, 63017" },
    { name: "Valley Park", zips: "63088" },
    { name: "Twin Oaks", zips: "63021" },
    { name: "Winchester", zips: "63021" },
    { name: "Clarkson Valley", zips: "63005" },
    { name: "Kirkwood", zips: "63122" },
    { name: "Sunset Hills", zips: "63127" },
    { name: "Fenton", zips: "63026" },
    { name: "Eureka", zips: "63025" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent West St. Louis County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Manchester Road Corridor", desc: "Serving Ballwin, Ellisville, Manchester, and West St. Louis County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Chesterfield, MO", route: "/cities/chesterfield-mo" },
    { name: "Fast passport renewal in Kirkwood, MO", route: "/cities/kirkwood-mo" },
    { name: "Emergency passport help in St. Charles, MO", route: "/cities/st-charles" },
    { name: "Urgent passport services in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Springfield, MO", route: "/cities/springfield-mo" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Ballwin remotely via secure courier. We do not have a walk-in office in Ballwin — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for West St. Louis County and the Manchester Road corridor.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of West St. Louis County including Ballwin, Ellisville, Manchester, Wildwood, and surrounding communities",
  serviceAreaIntro: "From the tree-lined neighborhoods of Ballwin and the retail hub of Manchester along Manchester Road to the executive homes of Town and Country and the sprawling suburbs of Wildwood, from the charming downtown of Kirkwood to the corporate campuses of Chesterfield — Fast Passport Center serves all of West St. Louis County. We regularly help travelers from Ballwin, Ellisville, and the surrounding communities get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Ballwin neighborhoods and the surrounding West St. Louis County area including Ellisville, Manchester, Wildwood, Town and Country, Des Peres, Chesterfield, Valley Park, Twin Oaks, and Winchester. If you are anywhere in western St. Louis County along the Manchester Road corridor, we have you covered.",
  howItWorksIntro: "Most Ballwin travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Ballwin travelers often face a 5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Ballwin and West St. Louis County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Ballwin? Here are the most common ones we hear from West St. Louis County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Ballwin travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Laura M.",
      location: "Ballwin, MO",
      rating: 5,
      text: "Our Paris anniversary trip was in 3 days and my passport had expired. Fast Passport Center had my renewal in 28 hours. I never left Ballwin. From Manchester Road to the Eiffel Tower in under a week — absolutely incredible!",
      service: "Passport Renewal",
    },
    {
      name: "Tom H.",
      location: "Manchester, MO",
      rating: 5,
      text: "Emergency business trip to Tokyo with 4 days notice. Fast Passport Center's dedicated agent handled everything. The daily updates kept me calm during the whole process. Best service I've ever used for travel documents.",
      service: "Emergency Passport",
    },
    {
      name: "Ellen R.",
      location: "Ellisville, MO",
      rating: 5,
      text: "Both kids needed first passports for our Caribbean cruise. Fast Passport Center walked us through the child passport process. Got them back in 4 days. Amazing service for West St. Louis County families!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "ballwin-1",
      name: "Ballwin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "15455 Manchester Rd",
      city: "Ballwin",
      state: "MO",
      zip: "63011",
      phone: "(636) 227-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Ballwin",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Ballwin facility on Manchester Road. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "ballwin-2",
      name: "St. Louis County — West County Government Center",
      type: "County Government Passport Acceptance",
      address: "82 Clarkson Wilson Centre",
      city: "Chesterfield",
      state: "MO",
      zip: "63017",
      phone: "(314) 615-5185",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "8 miles north of Ballwin",
      website: "https://stlouiscountymo.gov",
      websiteLabel: "St. Louis County Government",
      notes: "County passport acceptance center. Serves all of West St. Louis County. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "ballwin-3",
      name: "Manchester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1228 Big Bend Rd",
      city: "Manchester",
      state: "MO",
      zip: "63021",
      phone: "(636) 225-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles east of Ballwin",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Manchester area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "ballwin-4",
      name: "Des Peres Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11751 Manchester Rd",
      city: "Des Peres",
      state: "MO",
      zip: "63131",
      phone: "(314) 822-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles east of Ballwin",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Des Peres and Town and Country. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "ballwin-5",
      name: "Wildwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2460 Taylor Rd",
      city: "Wildwood",
      state: "MO",
      zip: "63040",
      phone: "(636) 458-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southwest of Ballwin",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wildwood and western St. Louis County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Ballwin photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at St. Louis County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Ballwin applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many West County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Ballwin travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Ballwin." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Ballwin address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Ballwin before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Ballwin for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Ballwin?", a: "Fast Passport Center offers fast passport renewal in Ballwin in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Ballwin?", a: "The nearest regional passport agency to Ballwin is the Chicago Passport Agency, approximately 310 miles northeast via I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Ballwin without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Ballwin?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from Ballwin — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for West St. Louis County residents." },
    { q: "Do you serve the entire West St. Louis County area?", a: "Absolutely. Fast Passport Center serves all of West St. Louis County including Ballwin, Ellisville, Manchester, Wildwood, Town and Country, and surrounding areas. Our courier service works seamlessly from any address along the Manchester Road corridor." },
    { q: "Can I expedite a child passport in Ballwin?", a: "Yes. Fast Passport Center expedites child passports in Ballwin for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk West County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Ballwin with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Manchester", address: "201 Highlands Blvd Dr, Manchester, MO 63011", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Ballwin", address: "14772 Manchester Rd, Ballwin, MO 63011", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Ellisville", address: "15810 Manchester Rd, Ellisville, MO 63011", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart Supercenter — Chesterfield", address: "100 Chesterfield Commons Dr, Chesterfield, MO 63005", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Manchester License Office",
      address: "14325 Manchester Rd, Manchester, MO 63011",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended. Closest to Ballwin.",
      featured: true,
    },
    {
      name: "Missouri DOR — Chesterfield License Office",
      address: "1768 Clarkson Rd, Chesterfield, MO 63017",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Chesterfield and western communities. REAL ID available.",
      featured: false,
    },
    {
      name: "Missouri DOR — South County License Office",
      address: "4542 Lemay Ferry Rd, St. Louis, MO 63129",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Major full-service DOR location. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "20 miles northeast of Ballwin",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international airport with direct flights worldwide. About 25 minutes from Ballwin via I-64/I-270.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: true,
    },
    {
      code: "COU",
      name: "Columbia Regional Airport",
      distance: "110 miles west of Ballwin",
      address: "11300 S Airport Dr, Columbia, MO 65201",
      note: "Regional airport with direct flights to major hubs. About 1 hour 50 minutes from Ballwin via I-70.",
      flightUrl: "https://www.flycou.com/",
      flightLabel: "COU Airport",
      featured: false,
    },
    {
      code: "SPI",
      name: "Abraham Lincoln Capital Airport",
      distance: "140 miles northeast of Ballwin",
      address: "1200 Capital Airport Dr, Springfield, IL 62707",
      note: "Regional airport serving central Illinois. About 2 hours 15 minutes from Ballwin via I-55.",
      flightUrl: "https://www.flyspi.com/",
      flightLabel: "SPI Airport",
      featured: false,
    },
  ],
};